export default "__VITE_ASSET__BSWajyWi__"